import React, { useState, useEffect,useRef } from "react";
import "./OrderCompleted.css";
import { Modal } from "react-bootstrap"; 
import { X } from "lucide-react";
import { useLocation, useNavigate,Link } from "react-router-dom";
import loader from '../../assests/loader.gif';
import API from '../../Utils/Api';
import { gettoastsuccess,gettoastwarning } from '../../Utils/Common';
import { useReactToPrint } from 'react-to-print';



const OrderCompleted = () => {
	const componentRef = useRef(null);
	const [loading,setLoading] = useState(true);
	const navigate = useNavigate();

  const location = useLocation();
	
  const [showFirst, setShowFirst] = useState(false);
  
  
  const [inputs,setInputs] = useState({order_id:'',order_number:'',event_id:'',event_title:'',event_image:'',event_end_date:'',category:'',location:'',age_start:'',age_end:''});
  const [tickets, setTickets] = useState([]);
  const [inputsm,setInputsm] = useState({id:'',ticket_id:'',ticket_name:'',ticket_number:'',first_name:'',last_name:'',age:'',email:'',country_code:'',mobile_number:'',qr_code:''});
  

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
      });
    document.title = `Order Completed | Your Friend My Friend`;
    document.getElementById('bodywrap').className='ordercomplete';
	const state = location.state;

	  if (!state || !state.order_number) {
		navigate('/');
		return;
	  }
	
	/* Start get order data */
		let formData = new FormData(); 
		formData.append('order_number', state.order_number);
		API.post('get_ticket_for_web',formData)
			.then(response => {
				setLoading(false);
			if(response.data.status === false){
				
			}else{
				setInputs({
					order_id:response.data.data.order_id,
					order_number:response.data.data.order_number,
					event_id:response.data.data.event_id,
					event_title:response.data.data.event_title,
					event_image:response.data.data.event_image,
					event_end_date:response.data.data.event_end_date,
					category:response.data.data.category,
					location:response.data.data.location,
					age_start:response.data.data.age_start,
					age_end:response.data.data.age_end,
				});
			   setTickets(response.data.data.tickets);
			}                  
		}).catch(error => {
			 
		});  
	 /* End get order data */
	
  },[location, navigate]);

const get_ticket_detail = (ticket_number) => {
	let formData = new FormData(); 
	formData.append('ticket_number', ticket_number);
	API.post('get_ticket_detail_for_web',formData)
		.then(response => {
			setLoading(false);
		if(response.data.status === false){
			
		}else{
			setInputsm({
				id:response.data.data.id,
				ticket_id:response.data.data.ticket_id,
				ticket_name:response.data.data.ticket_name,
				ticket_number:response.data.data.ticket_number,
				first_name:response.data.data.first_name,
				last_name:response.data.data.last_name,
				age:response.data.data.age,
				email:response.data.data.email,
				country_code:response.data.data.country_code,
				mobile_number:response.data.data.mobile_number,
				qr_code:response.data.data.qr_code,
			});
			setShowFirst(true);
		}                  
	}).catch(error => {
		 
	});  
}
const send_to_my_email = (event,ticket_number) => {
	event.preventDefault();
	setLoading(true);
	let formData = new FormData(); 
	formData.append('ticket_number', ticket_number);
	API.post('send_to_my_email',formData)
		.then(response => {
			setLoading(false);
		if(response.data.status === false){
			gettoastwarning(response.data.message,'');
		}else{
			gettoastsuccess(response.data.message,'');
		}                  
	}).catch(error => {
		 
	});  
}

  const handlePrint = useReactToPrint({
    contentRef: componentRef, 
  });

  return (
    <>
      <div className="container py-5">
        <div className="comple">
          <div className="row">
            <div className="col-md-12 order-first">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/modal-right.png'}
                alt="modal-right"
                className="img-fluid"
              />
              <h3>Order completed</h3>
              <p>
                Thank you for your purchase—your ticket(s) are booked, and a
                confirmation email is on its way to your inbox! You will receive
                a copy of the tickets in your email.
              </p>
            </div>
          </div>
		{tickets && tickets.map((val,index) => {
				return(
				  <div className="row d-flex align-items-center uio">
					<div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6 p-0">
					  <h3>{val.first_name} {val.last_name}, {val.age}</h3>
					  <p>
						{val.email}
						<br />
						{val.country_code}{val.mobile_number}
					  </p>
					</div>
					<div className="col-md-6 col-sm-6 col-6 text-end p-0 links">
					  <div className="orak">
						<button  onClick={() =>get_ticket_detail(val.ticket_number)} >View Ticket</button>
					  </div>
					  
					</div>
				  </div>
				)
			  })}
          

          <div className="row d-flex align-items-center text-center text-md-start apple"> 
            <div className="col-md-12 col-lg-6 p-0 mb-3 mb-lg-0">
              <h2> Get the app </h2>
              <p>
                Save your tickets and find your events in your account in the
                app!
              </p>
            </div>
            <div className="col-md-12 col-lg-6 p-0 text-center text-lg-end">
              <Link href="https://apps.apple.com/us/app/your-friend-my-friend/id6748553590" target="_blank">
                <img
                  src={process.env.REACT_APP_BASE_URL + 'assests/images/modal-app.png'}
                  alt="App Store"
                  className="me-2"
                />
              </Link>
              <Link href="https://play.google.com/store/apps/details?id=com.yourfriend.myfriend" target="_blank">
                <img src={process.env.REACT_APP_BASE_URL + 'assests/images/modal-google.png'} alt="Google Play" />
              </Link>
            </div>
			<div className="text-center mt-5">
              <Link className="btn brow-bu text-decoration-none" to="/upcoming-events">View More Events</Link>
            </div>
          </div>
        </div>
      </div>


      <Modal show={showFirst} onHide={() => setShowFirst(false)} centered size="lg">
        <div className="south" ref={componentRef}>
          <div className="close-btn no-print" onClick={() => setShowFirst(false)}>
            <X size={30} />
          </div>
          <Modal.Header>
            <Modal.Title>
              <div className="row">
                <h3>My Ticket</h3>
                <p>{inputs.event_title} (Ages {inputs.age_start} - {inputs.age_end}) {inputsm.ticket_name}</p>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="container-fluid"  >
              <div className="row">
                <div className="col-md-12 p-0 naing">
                  <h5>{inputsm.first_name} {inputsm.last_name}, {inputsm.age}</h5>
                  <p className="mb-1">{inputsm.email}</p>
                  <p>{inputsm.country_code}{inputsm.mobile_number}</p>
                </div>
              </div>
              <div className="row align-items-center">
                <div className="col-md-5 p-0 likhy">
                  <img
                    src={inputsm.qr_code}
                    alt="QR Code"
                    className="img-fluid"
                  />
                </div>
                <div className="col-md-7 d-flex justify-content-end p-0 llinku no-print">
                  <Link href="#" onClick={(e) => { e.preventDefault(); handlePrint(); }}>Print ticket</Link>
                  <Link href="#" onClick={(event) => send_to_my_email(event,inputsm.ticket_number)}>Send to my email</Link>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
          <div className="row d-flex align-items-center text-center text-md-start">
            <div className="col-md-12 col-lg-6 p-0 mb-3 mb-lg-0">
              <h2> Get the app </h2>
              <p>Save your tickets and find your events in your account in the app!</p>
            </div>
            <div className="col-md-12 col-lg-6 p-0 text-center text-lg-end">
              <Link href="#"><img src={process.env.REACT_APP_BASE_URL + 'assests/images/modal-app.png'} alt="App Store" className="me-2" /></Link>
              <Link href="#"><img src={process.env.REACT_APP_BASE_URL + 'assests/images/modal-google.png'} alt="Google Play" /></Link>
            </div>
          </div>
          </Modal.Footer>
        </div>
      </Modal>
	  {loading && (
	   <div className="loadingClass">
			<img src={loader} alt="loader"/>
		</div>
	   )}
    </>
  );
};

export default OrderCompleted;
